<template>
  <v-card class="prelogin" outlined tile>
    <v-card-title v-if="showMaintMsg" class="prelogin__title">
      <sc-text :field="this.fields.MaintenanceMsgTitle" />
    </v-card-title>
    <v-card-text v-if="showMaintMsg" class="prelogin__content">
      <sc-rich-text :field="this.fields.MaintenanceMsgContent" />
    </v-card-text>
    <v-card-title class="prelogin__title">
      <sc-text :field="this.fields.CardTitle" />
    </v-card-title>
    <v-card-text class="prelogin__content">
      <sc-rich-text :field="this.fields.CardContent" />
    </v-card-text>

    <v-card-actions class="prelogin__link-container">
      <v-btn
        v-if="!this.isSitecoreExperienceEditorOn && this.displayActionButton"
        class="prelogin__link"
        text
        tile
        color="#00629B"
        :target="fields.CardLink.value.target"
        :href="fields.CardLink.value.href"
        >{{ fields.CardLink.value.text }}</v-btn
      >
      <sc-link
        class="prelogin__link--editor"
        v-else-if="this.isSitecoreExperienceEditorOn"
        :field="this.fields.CardLink"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import { Text, RichText, Link, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'PreLoginCard',
  data: function() {
    return {};
  },
  components: {
    ScRichText: RichText,
    ScText: Text,
    ScLink: Link,
    isExperienceEditorActive,
  },
  computed: {
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
    showMaintMsg () {
      return this.fields.ShowMaintenanceMsg.value
    },
    displayActionButton(){
      if(this.fields.CardLink === null || typeof(this.fields.CardLink) === 'undefined'){
        return false;
      }
      if(this.fields.CardLink.value === null || typeof(this.fields.CardLink.value) === 'undefined'){
        return false;
      }
      if(this.fields.CardLink.value.href === null || this.fields.CardLink.value.href === '' || typeof(this.fields.CardLink.value.href) === 'undefined'){
        return false;
      }
      return true;
    }
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        ShowMaintenanceMsg: {
          default: false
        }
      }),
    },
  },
  mounted: function() {},
  methods: {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.prelogin {
  padding: 48px 48px 0;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    padding: 32px 16px 0;
  }

  @media #{map-get($display-breakpoints, 'sm-only')} {
    margin: 57px 96px 0;
  }

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    border: none !important;
    background-color: transparent !important;
  }

  &__title {
    font-size: 32px;
    font-weight: bold;
    color: map-deep-get($colors, 'link', 'base');
    word-break: initial;
    padding: 0 0 32px;

    @media #{map-get($display-breakpoints, 'xs-only')} {
      font-size: 22px;
      text-align: left;
    }
  }

  &__content {
    font-size: 18px;
    line-height: 158%;
    padding: 0;

    @media #{map-get($display-breakpoints, 'md-and-up')} {
      color: map-deep-get($colors, 'blue-text', 'base') !important;
    }

    @media #{map-get($display-breakpoints, 'sm-only')} {
      font-size: 16px;
    }

    @media #{map-get($display-breakpoints, 'xs-only')} {
      font-size: 14px;
    }
  }

  &__link {
    font-size: 12px !important;
    font-weight: 400;
    font-style: normal;
    border-bottom: 2.5px solid map-deep-get($colors, 'link', 'base');
    text-transform: none;
  }

  &__link-container {
    padding-left: 0;
  }
}
</style>
